import { useEffect, useState } from 'react';

/**
 * Returns `value` delayed by `delay` ms. Each new value resets the timer,
 * so rapid input (e.g. typing in a search field) produces a single update.
 */
export function useDebounce<T>(value: T, delay: number): T {
  const [debounced, setDebounced] = useState(value);

  useEffect(() => {
    const timer = setTimeout(() => setDebounced(value), delay);
    return () => clearTimeout(timer);
  }, [value, delay]);

  return debounced;
}
